import { Button, Instagram, SocialNetworksAvailables, TikTok, Twitter, Youtube } from '@hub/shared'
import { SqCallout } from '@squidit/react-css'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import './box-token-expired.component.scoped.scss'

interface Props {
  socialNetworkObject: Instagram | Youtube | Twitter | TikTok
  onRenewToken: (id: string, type: string) => void
  type: SocialNetworksAvailables
}

export default ({ socialNetworkObject, onRenewToken, type }: Props) => {
  const [t] = useTranslation('cardSocialNetwork')

  const handleRenewToken = useCallback(() => {
    if (onRenewToken && typeof onRenewToken === 'function') {
      onRenewToken(socialNetworkObject.id, type)
    }
  }, [onRenewToken, socialNetworkObject.id, type])

  return (
    <SqCallout className="mb-0" title={t('warnings.invalidToken.title')} smallIconStyle icon="fa-solid fa-diamond-exclamation">
      <div className="warning-inside">
        <p>{t('warnings.invalidToken.message')}</p>
        <Button onClick={() => handleRenewToken()} size="sm" className="button-invalid-token">
          {t('warnings.invalidToken.button')}
        </Button>
      </div>
    </SqCallout>
  )
}
